import moment from "moment";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import PaginatedItems from "../../../common/Pagination";
import Modal from "react-modal";
import {
  getChainNameAction,
  getHelloAdminAction,
  getUserRoleAction,
  getUserTypeAction,
} from "../../../redux/actions/HelloAdminAction";
import { SearchIcon } from "../../../Utils/SvgIcons";
import {
  clearCurrentPage,
  clearDuration,
  getApiParams,
} from "../ProviderProfileDetails/helper";
import {
  initialFilterState,
  tableHeader,
  TableHeaderAdmin,
  tableHeaderChain,
} from "./helper";
import { AddUserPopup } from "./AddUserPopup";
import { getNetworkMenuId, getNetworkUserTypeId } from "../../../Utils/types";
import { HistoryAdminDetailPopup } from "./HistoryAdminDetailPopup";

const HelloAdmin = () => {
  const dispatch = useDispatch();
  const [searchFilter, setSearchFilter] = useState({
    ...initialFilterState,
    userTypeId: getNetworkUserTypeId(),
  });
  const [isEditUser, setIsEditUser] = useState(null);
  const [showHistoryPopup, setShowHistoryPopup] = useState(null);
  const [showChainName, setShowChainName] = useState(false);

  const getHelloAdminReducer = useSelector((state) => state?.HelloAdminReducer);
  const chainUserProviderId = getHelloAdminReducer?.getUserTypeDetails?.filter(
    (ele) => ele?.roleName === "Chain Provider"
  )?.[0]?.roleId;
  const globalReducer = useSelector((state) => state?.globalReducer);
  const { apiParams } = getApiParams({ globalReducer });

  useEffect(() => {
    dispatch(getUserTypeAction());
    dispatch(getChainNameAction());
  }, []);

  useEffect(() => {
    dispatch(getUserRoleAction(searchFilter?.userTypeId));
    setSearchFilter({ ...searchFilter, userRoleId: null });
  }, [searchFilter?.userTypeId]);

  useEffect(() => {
    if (showHistoryPopup === null) {
      dispatch(getHelloAdminAction({ ...searchFilter, ...apiParams }));
    }
  }, [globalReducer?.getCurrentPage, showHistoryPopup]);

  const changeHandler = (name, value) => {
    setSearchFilter({ ...searchFilter, [name]: value });
  };

  const handleSearch = () => {
    clearCurrentPage(dispatch);
    dispatch(getHelloAdminAction({ ...searchFilter, ...apiParams, page: 1 }));
    if (searchFilter?.userTypeId == chainUserProviderId) {
      setShowChainName(true);
    } else {
      setShowChainName(false);
    }
  };

  const handleClearFilter = () => {
    setSearchFilter({
      ...initialFilterState,
      userTypeId: getNetworkUserTypeId(),
    });
    dispatch(
      getHelloAdminAction({
        ...initialFilterState,
        userTypeId: getNetworkUserTypeId(),
      })
    );
    clearDuration(dispatch);
    clearCurrentPage(dispatch);
    setShowChainName(false);
  };

  const SortHandler = (sortColumnName, sortDirection) => {
    clearCurrentPage(dispatch);
    setSearchFilter({
      ...searchFilter,
      ...apiParams,
      SortColumn: sortColumnName,
      sortDirection: sortDirection,
    });
    dispatch(
      getHelloAdminAction({
        ...searchFilter,
        ...apiParams,
        SortColumn: sortColumnName,
        sortDirection: sortDirection,
      })
    );
  };

  return (
    <div className="right-section" style={{ padding: "20px" }}>
      <div className="card staff-details-section">
        <div className="card-body">
          <h4> Hello Admin </h4>
          <div className="row-filter">
            <input
              type="email"
              placeholder="Email ID"
              className="white-form-select"
              value={searchFilter?.email}
              onChange={(e) => changeHandler("email", e.target.value)}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  handleSearch(event);
                }
              }}
            />
            <input
              type="text"
              className="white-form-select"
              minLength={10}
              maxLength={10}
              placeholder="Mobile Number"
              value={
                searchFilter?.mobileNo === null ? "" : searchFilter?.mobileNo
              }
              onChange={(e) =>
                changeHandler(
                  "mobileNo",
                  e.target.value === "" ? null : e.target.value
                )
              }
              onKeyPress={(event) => {
                const re = /[0-9]+/g;
                if (!re.test(event.key)) {
                  event.preventDefault();
                }
                if (event.key === "Enter") {
                  handleSearch(event);
                }
              }}
            />
            <select
              className="white-form-select"
              value={
                searchFilter?.userTypeId === null
                  ? ""
                  : searchFilter?.userTypeId
              }
              onChange={(e) =>
                changeHandler(
                  "userTypeId",
                  e.target.value === "" ? null : e.target.value
                )
              }
            >
              <option value="">User Type</option>
              {getHelloAdminReducer?.getUserTypeDetails?.map((ele, index) => {
                return (
                  <option key={index} value={ele?.roleId}>
                    {ele?.roleName}
                  </option>
                );
              })}
            </select>
            <select
              className="white-form-select"
              value={
                searchFilter?.userRoleId === null
                  ? ""
                  : searchFilter?.userRoleId
              }
              onChange={(e) =>
                changeHandler(
                  "userRoleId",
                  e.target.value === "" ? null : e.target.value
                )
              }
            >
              <option value="">Role</option>
              {getHelloAdminReducer?.getUserRoleDetails?.map((ele, index) => {
                return (
                  <option key={index} value={ele?.roleId}>
                    {ele?.roleName}
                  </option>
                );
              })}
            </select>
            <div className="search" type="button" onClick={handleSearch}>
              <a className="sidebar-links">
                <SearchIcon />
                <span className="sidebar-link-text">Search</span>
              </a>
            </div>
            <div className="search" type="button" onClick={handleClearFilter}>
              <a className="sidebar-links">
                <span className="sidebar-link-text">Clear All</span>
              </a>
            </div>
          </div>
          <div className="row-results">
            <div className="results">
              Total <span>{globalReducer?.getTotalCount}</span> results
            </div>
            <div>
              {getNetworkMenuId()?.canEdit && (
                <button
                  className={`btn search__btn`}
                  type="button"
                  onClick={() => setIsEditUser(0)}
                >
                  <i className="fa-solid fa-plus pt-1 c-white"></i>&nbsp; Add
                  User
                </button>
              )}
            </div>
          </div>
          <div className="table-responsive __custom__properties">
            <table className="table">
              <thead>
                <tr className="avanishtbl">
                  {showChainName
                    ? tableHeaderChain?.map((ele, index) => {
                        return (
                          <TableHeaderAdmin
                            key={index}
                            header={ele?.name}
                            searchFilter={searchFilter}
                            SortHandler={SortHandler}
                          />
                        );
                      })
                    : tableHeader?.map((ele, index) => {
                        return (
                          <TableHeaderAdmin
                            key={index}
                            header={ele?.name}
                            searchFilter={searchFilter}
                            SortHandler={SortHandler}
                          />
                        );
                      })}
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {getHelloAdminReducer?.getHelloAdminDetails?.map(
                  (ele, index) => {
                    return (
                      <tr key={index}>
                        <td
                          className={`${
                            ele?.isActive ? "tbl-textgreen" : "tbl-textred"
                          } width-200`}
                        >
                          {ele?.name}
                        </td>
                        <td
                          className="width-200"
                          style={{ wordBreak: "break-all" }}
                        >
                          {ele?.email}
                        </td>
                        <td>
                          {ele?.mobileNumber === "" ? "-" : ele?.mobileNumber}
                        </td>
                        <td>{ele?.userType}</td>
                        <td
                          className="tooltip1"
                          style={{ width: "200px", padding: "10px 10px" }}
                        >
                          {ele?.userRole.split(" ").length > 5 && (
                            <span className="tooltiptext">{ele?.userRole}</span>
                          )}
                          {ele?.userRole === ""
                            ? "-"
                            : ele?.userRole.split(" ").slice(0, 5).join(" ")}
                          {ele?.userRole.split(" ").length > 5 && "..."}
                        </td>
                        {showChainName && (
                          <td>
                            {ele?.providerChainName === ""
                              ? "-"
                              : ele?.providerChainName}
                          </td>
                        )}
                        <td className="width-200">
                          {ele?.updatedDateTime === null
                            ? "-"
                            : moment(ele?.updatedDateTime).format(
                                "DD MMMM YYYY"
                              )}
                        </td>
                        <td
                          className="tbl-actionimg"
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            onClick={() => setIsEditUser(ele?.userID)}
                            src="./images/edit-icon.png"
                            alt="exportsquare"
                          />
                          {ele?.userType === "Chain Provider" && (
                            <button
                              className="btn _action__btn"
                              type="button"
                              onClick={() => {
                                setShowHistoryPopup(ele);
                                clearCurrentPage(dispatch);
                              }}
                            >
                              <i
                                className="fa fa-history"
                                style={{
                                  color: "rgb(109 113 221)",
                                  marginLeft: "5px",
                                }}
                              ></i>
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  }
                )}
              </tbody>
            </table>
          </div>
          <div className="pagination-row">
            {globalReducer?.getTotalCount !== 0 && (
              <PaginatedItems
                totalCount={globalReducer?.getTotalCount}
                perPageData={searchFilter?.rows}
              />
            )}
          </div>
          <Modal
            isOpen={isEditUser !== null}
            className="modal-add-user-popup modal-role-user-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <AddUserPopup
              isEditUser={isEditUser}
              setIsEditUser={setIsEditUser}
              canEdit={getNetworkMenuId()?.canEdit}
              searchFilter={searchFilter}
              apiParams={apiParams}
            />
          </Modal>
          <Modal
            isOpen={showHistoryPopup !== null}
            className="modal-history-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <HistoryAdminDetailPopup
              showHistoryPopup={showHistoryPopup}
              setShowHistoryPopup={setShowHistoryPopup}
            />
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default HelloAdmin;
